import { useScreenSize } from '@/hooks';
import type { SVGProps } from 'react';

type Props = Omit<SVGProps<SVGSVGElement>, 'width' | 'height'> & {
    width?: number;
    height?: number;
};
export const CafeIcon = (props: Props) => {
    const { width = 66, height = 46, fill = 'currentColor', ...restProps } = props;
    const { scaleHeightPixel, scaleWidthPixel } = useScreenSize();

    return (
        <svg xmlns="http://www.w3.org/2000/svg" width={scaleWidthPixel(width)} height={scaleHeightPixel(height)} viewBox="0 0 66 46" {...restProps} fill="none">
            <g clip-path="url(#clip0_13138_50753)">
                <path d="M56.3397 42.3608H0V46.0001H56.3397V42.3608Z" fill={fill} />
                <path 
                    d="M66 10.6084C66 6.02294 62.2635 2.31092 57.6885 2.31092C56.5037 2.31092 55.3554 2.58386 54.3165 3.05696V0H2.0961V30.0237L9.53272 38.0301H46.8616L54.2983 30.0237V26.1297L64.0132 15.9763C65.2891 14.4842 65.9818 12.5736 65.9818 10.6084H66ZM50.6711 28.5862L45.2941 34.3726H11.1185L5.7415 28.5862V3.63924H50.6711V28.5862ZM61.3157 13.538L54.2983 20.8528V7.46044C55.1732 6.51424 56.3761 5.93196 57.6703 5.93196C60.2403 5.93196 62.3364 8.02452 62.3364 10.5902C62.3364 11.7002 61.9536 12.7555 61.2974 13.5198L61.3157 13.538Z" 
                    fill={fill} />
            </g>
            <defs>
                <clipPath id="clip0_13138_50753">
                <rect width="66" height="46" fill="white"/>
                </clipPath>
            </defs>
        </svg>
    );
};
